export const classSubject= [
	{
		id: "SU128394",
		name: "English",
		code: "101",
		type: "Theory",
		status: "Active",
		key:1
	},
	{
		id: "SU128393",
		name: "Math",
		code: "102",
		type: "Theory",
		status: "Active",
		key:2
	},
	{
		id: "SU128392",
		name: "Physics",
		code: "103",
		type: "Practical",
		status: "Active",
		key:3
	},
	{
		id: "SU128391",
		name: "Chemistry",
		code: "104",
		type: "Practical",
		status: "Active",
		key:4
	},
	{
		id: "SU128390",
		name: "Biology",
		code: "105",
		type: "Practical",
		status: "Inactive",
		key:5
	},
	{
		id: "SU128389",
		name: "Higher Math",
		code: "106",
		type: "Practical",
		status: "Active",
		key:6
	},
	{
		id: "SU128388",
		name: "Information Technology",
		code: "107",
		type: "Practical",
		status: "Active",
		key:7
	},
	{
		id: "SU128387",
		name: "Moral Education",
		code: "108",
		type: "Practical",
		status: "Inactive",
		key:8
	},
	{
		id: "SU128388",
		name: "Finance",
		code: "109",
		type: "Thory",
		status: "Active",
		key:9
	},
	{
		id: "SU128386",
		name: "Economics",
		code: "110",
		type: "Theory",
		status: "Active",
		key:10
	}
];
